import { nameSpace } from "../constants/cardStatement.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const downloadCardStatement = (state = initialState, action) => {
  switch (action.type) {
    case `DOWNLOAD_${nameSpace}_REQUEST`:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case `DOWNLOAD_${nameSpace}_SUCCESS`:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case `DOWNLOAD_${nameSpace}_FAILURE`:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };
    case `DOWNLOAD_${nameSpace}_RESET`:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
